/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `basic_food` - Basic food
* `modelled_food` - Modelled food
* `external_emission_factor` - External emission factor
* `purchased_good` - Purchased good
* `non_food` - Non-food
 */
export type IngredientModelledAsEnum = typeof IngredientModelledAsEnum[keyof typeof IngredientModelledAsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IngredientModelledAsEnum = {
  basic_food: 'basic_food',
  modelled_food: 'modelled_food',
  external_emission_factor: 'external_emission_factor',
  purchased_good: 'purchased_good',
  non_food: 'non_food',
} as const;
